import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import {
  captureExamEvent,
  EXAM_EVENTS,
  EXAM_STEP,
} from 'src/services/posthogEvents';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { Api } from 'src/models/Api.model';
import { I18NextNS } from 'src/models/Language.model';

import useCancelCaptureImages from './camera/useCancelCaptureImages';

export default function useCheckNavigation() {
  const {
    session,
    resetSession,
    setLeftUrl,
    setRightUrl,
    isCanceling,
    hasStarted,
  } = useRemoteBoundStore();

  const {
    t,
    i18n: { language },
  } = useTranslation(I18NextNS.PAGES);

  const history = useHistory();
  const location = useLocation();

  const { handleCancelCapture } = useCancelCaptureImages();

  const checkNavigation = (e: any) => {
    if (location.pathname === '/session-preview') {
      e.preventDefault(); // stop navigation

      Api.confirmBox({
        title: t('bootbox.title.Confirm', { ns: I18NextNS.COMMON }),
        message: t('newExam.confirmExitImaging'),
        callback: (result) => {
          if (!result) {
            return;
          }

          const order_id = session.orderId;
          const exam_id = session.iid;

          if (!isCanceling && hasStarted) {
            handleCancelCapture();
          }

          setLeftUrl('');
          setRightUrl('');
          resetSession();

          captureExamEvent(EXAM_EVENTS.EXAM_PAUSED, {
            order_id,
            exam_id,
            step: EXAM_STEP.IMAGING,
          });

          let path;
          if (e.target.href) {
            path = e.target.href.split('#')[1];
          } else {
            const navLink = e.target.closest('a');
            path = navLink?.getAttribute('href')?.split('#')[1];
          }

          if (path) {
            history.push(path);
          }
        },
        locale: language,
      });
    }
  };

  return { checkNavigation };
}
